module.exports = __webpack_public_path__ + "static/img/img-p3.1e1333f6.jpg";